import axiosInstance from '@/api/axiosInstance';
import { buildQueryString } from '@/utils/query';
import {
  AuthProviderRead, AuthProviderCreate, AuthProviderUpdate, AuthProviderFilterParams,
  PaginatedAuthProvidersResponse, PublicProvider,
} from '@/types/auth-provider.types';
import { AUTH_PROVIDER_ENDPOINTS } from '@/api/endpoints/auth-provider.endpoints';
import { ManagementApiService, FormApiService } from '@/types/management.types';

export const AuthProviderManagementApiService: ManagementApiService<AuthProviderRead, AuthProviderFilterParams> = {
  getAll: async (offset = 0, limit = 20, filters?: AuthProviderFilterParams): Promise<PaginatedAuthProvidersResponse<AuthProviderRead>> => {
    const query = buildQueryString({ ...filters, offset, limit });
    return (await axiosInstance.get<PaginatedAuthProvidersResponse<AuthProviderRead>>(`${AUTH_PROVIDER_ENDPOINTS.PROVIDERS}${query}`)).data;
  },
  deleteItem: async (id: number): Promise<void> => {
    await axiosInstance.delete(AUTH_PROVIDER_ENDPOINTS.PROVIDER_DETAIL(id));
  },
};

export const AuthProviderFormApiService: FormApiService<AuthProviderRead, AuthProviderCreate, AuthProviderUpdate> = {
  getItem: async (id: number | string): Promise<AuthProviderRead> =>
    (await axiosInstance.get<AuthProviderRead>(AUTH_PROVIDER_ENDPOINTS.PROVIDER_DETAIL(id))).data,
  createItem: async (data: AuthProviderCreate): Promise<AuthProviderRead> =>
    (await axiosInstance.post<AuthProviderRead>(AUTH_PROVIDER_ENDPOINTS.PROVIDERS, data)).data,
  updateItem: async (id: number | string, data: AuthProviderUpdate): Promise<AuthProviderRead> =>
    (await axiosInstance.put<AuthProviderRead>(AUTH_PROVIDER_ENDPOINTS.PROVIDER_DETAIL(id), data)).data,
};

export const PublicAuthProviderApi = {
  getPublicProviders: async (): Promise<PublicProvider[]> =>
    (await axiosInstance.get<PublicProvider[]>(AUTH_PROVIDER_ENDPOINTS.PUBLIC_PROVIDERS)).data ?? [],
};

export const AuthProviderApi = {
  Management: AuthProviderManagementApiService,
  Form: AuthProviderFormApiService,
  Public: PublicAuthProviderApi,
};

// backward compatibility
export const AuthProviderInternalApi = {
  getProviders: AuthProviderManagementApiService.getAll,
  getProviderById: AuthProviderFormApiService.getItem!,
  createProvider: AuthProviderFormApiService.createItem,
  updateProvider: AuthProviderFormApiService.updateItem,
  deleteProvider: AuthProviderManagementApiService.deleteItem,
};